import React from "react";
import { Title, Link, List, Container, Stack, Text, useViewport, } from "@bookingcom/bui-react";
import "../TravellerFooter.types";
import styles from "../TravellerFooter.module.css";
var FooterLists = function (_a) {
    var lists = _a.lists;
    var isMedium = useViewport().isMedium;
    return (React.createElement(Container, { centered: true, className: styles["footer-lists"], attributes: { "data-testid": "footer-lists" } },
        React.createElement(Stack, { direction: "row", justifyContent: isMedium ? "start" : "space-between", gap: 6 }, lists.map(function (list) { return (React.createElement(Stack, { key: list.title, gap: 3, attributes: list.attributes, className: styles["footer-lists--list"] },
            React.createElement(Title, { title: list.title, titleTagName: "h3" }),
            React.createElement(List, { items: list.items.map(function (_a) {
                    var href = _a.href, text = _a.text, className = _a.className, attributes = _a.attributes, onClick = _a.onClick;
                    return ({
                        content: (React.createElement(Link, { key: href + text, variant: "secondary", text: React.createElement(Text, { variant: "body_2", tagName: "span" }, text), href: href, className: className, attributes: attributes, onClick: onClick })),
                    });
                }) }))); }))));
};
export default FooterLists;
